import * as React from 'react';

import { MapPin } from 'lucide-react';

import type { CreateDeliveryAddress, DeliveryAddress, SiteType } from '@klareospace/pharos-lib-types';
import { formatDeliveryAddress, formatRequestedAddress } from '@klareospace/pharos-lib-utils';

import { IconText, resolveSiteTypeIcon } from '@klareospace/pharos-lib-web-utils';

// ─── Types ────────────────────────────────────────────────────────────────────

interface LocationCellProps {
  address?: DeliveryAddress;
  /** Client-submitted raw address, used as a final fallback when `address` is unresolved (no coordinates matched at order creation). */
  requestedAddress?: CreateDeliveryAddress;
  siteName?: string;
  siteType?: SiteType;
}

// ─── Component ────────────────────────────────────────────────────────────────

export function LocationCell({ address, requestedAddress, siteName, siteType }: LocationCellProps): React.JSX.Element {
  const Icon = resolveSiteTypeIcon(siteType, MapPin);
  const addressLabel = formatDeliveryAddress(address) || formatRequestedAddress(requestedAddress);
  const label = (siteName ?? addressLabel) || '—';

  return (
    <IconText icon={Icon} size="sm">
      <span>{label}</span>
    </IconText>
  );
}
